import React from 'react';
import { fileName, fileUrl } from '../../../../../../util/file_url'
import axios from 'axios'

export default class PDFDisplay extends React.Component {
    constructor(props) {
        super();
        this.state = {
            isLoading: false,
            pdf: null,
        };
    }

    componentDidMount = async () => {
        this.loadPDF();
    };

    componentDidUpdate = async (prevProps) => {
        // Reload PDF if the filename changes
        if (prevProps.filename !== this.props.filename) {
            // Clean up the old blob URL
            if (this.state.pdf) {
                URL.revokeObjectURL(this.state.pdf);
            }
            this.setState({ pdf: null }, () => {
                this.loadPDF();
            });
        }
    };

    componentWillUnmount = () => {
        // Clean up the blob URL when component unmounts
        if (this.state.pdf) {
            URL.revokeObjectURL(this.state.pdf);
        }
    };

    loadPDF = async () => {
        try {
            this.setState({ isLoading: true });
            let response = await axios.get(
                fileUrl(this.props.filename),
                { responseType: "arraybuffer" }
            );
            var file = new Blob([response.data], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            this.setState({
                pdf: fileURL,
                isLoading: false
            });
        } catch (error) {
            console.error('Error loading PDF:', error);
            this.setState({ isLoading: false });
        }
    };

    render() {
        return this.state.pdf ? (
            <div id="attachment-form-preview" style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                overflow: 'hidden'
            }}>
                <iframe
                    title={fileName(this.props.filename)}
                    src={`${this.state.pdf}`}
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none'
                    }}
                />
            </div>
        ) : (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#081F5F',
                    fontSize: '16px'
                }}>
                    {this.state.isLoading ? 'Loading PDF...' : 'Loading...'}
                </div>
            );
    }
}